import { useQuery } from "@tanstack/react-query";
import { getResult } from "@/lib/api";

export function useResult(eventLogId: string | undefined) {
  return useQuery({
    queryKey: ["result", eventLogId],
    queryFn: () => getResult(eventLogId!),
    enabled: !!eventLogId,
    staleTime: 10 * 60 * 1000,
    gcTime: 30 * 60 * 1000,
  });
}
